import { NavLink, Outlet } from "react-router-dom";
import {
  Building2,
  CreditCard,
  LifeBuoy,
  Palette,
  type LucideIcon,
} from "lucide-react";
import { AppShell } from "@/app/components/AppShell";

const NAV_ITEMS: { to: string; label: string; icon: LucideIcon }[] = [
  { to: "/settings/business", label: "Business", icon: Building2 },
  { to: "/settings/brand", label: "Brand", icon: Palette },
  { to: "/settings/billing", label: "Billing", icon: CreditCard },
  { to: "/settings/support", label: "Support", icon: LifeBuoy },
];

export function SettingsLayout() {
  return (
    <AppShell
      center={
        <h1 className="truncate text-base font-semibold text-slate-900">
          Settings
        </h1>
      }
    >
      <div className="mx-auto flex max-w-5xl flex-col gap-8 px-4 py-10 sm:px-8 md:flex-row md:gap-10">
        {/* Left nav — horizontal on mobile, vertical on md+ */}
        <nav className="flex-shrink-0 md:w-44">
          <ul className="flex gap-1 md:flex-col">
            {NAV_ITEMS.map((item) => {
              const Icon = item.icon;
              return (
                <li key={item.to}>
                  <NavLink
                    to={item.to}
                    className={({ isActive }) =>
                      `flex items-center gap-2.5 rounded-lg px-3 py-2 text-sm font-medium transition ${
                        isActive
                          ? "bg-slate-900 text-white"
                          : "text-slate-600 hover:bg-surface-hover hover:text-slate-900"
                      }`
                    }
                  >
                    <Icon className="h-4 w-4 flex-shrink-0" strokeWidth={1.75} />
                    {item.label}
                  </NavLink>
                </li>
              );
            })}
          </ul>
        </nav>

        {/* Content */}
        <main className="min-w-0 flex-1">
          <Outlet />
        </main>
      </div>
    </AppShell>
  );
}
